import {StyleSheet} from "aphrodite";
import * as React from "react";
import {ReactEditor, useSlate, type RenderElementProps} from "slate-react";

import {semanticColor, spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body} from "@khanacademy/wonder-blocks-typography";

import {isWithinTableHeader} from "../helpers/table-helpers.ts";

export default function TableCellNode(
    props: RenderElementProps,
): React.ReactElement {
    const {element, attributes, children} = props;

    const editor = useSlate();
    const path = ReactEditor.findPath(editor, element);
    const renderTh = isWithinTableHeader(editor, path);
    const tag = renderTh ? "th" : "td";

    return (
        <Body
            {...attributes}
            style={[styles.cell, renderTh && styles.th]}
            tag={tag}
        >
            {children}
        </Body>
    );
}

const styles = StyleSheet.create({
    cell: {
        display: "table-cell",
        padding: spacing.xSmall_8,
        border: `1px solid ${semanticColor.core.border.neutral.subtle}`,
        position: "relative",
    },
    th: {
        backgroundColor: semanticColor.core.background.neutral.subtle,
        fontWeight: "bold",
    },
});
